// Preprocess Obsidian-style wiki-links to real markdown links so
// react-markdown can render them as clickable elements. Custom-scheme
// href (docs://<target>) is intercepted by the viewer's link handler
// to navigate within the docs UI without triggering a browser navigation.
//
// Handles: [[Name]], [[Name|Alias]], [[folder/Name]], [[folder/Name|Alias]]

const WIKI_LINK_RE = /\[\[([^\]|]+)(?:\|([^\]]+))?\]\]/g;

export function preprocessWikiLinks(markdown: string): string {
  return markdown.replace(WIKI_LINK_RE, (_match, target: string, alias?: string) => {
    const cleanTarget = target.trim();
    const label = (alias ?? cleanTarget).trim();
    const href = `docs://${encodeURIComponent(cleanTarget)}`;
    return `[${label}](${href})`;
  });
}

/** True when a link href is one of ours (from wiki-link preprocessing). */
export function isInternalDocLink(href: string | undefined): boolean {
  return !!href && href.startsWith("docs://");
}

/** Decode our custom scheme back to the doc target. */
export function decodeDocHref(href: string): string {
  return decodeURIComponent(href.replace(/^docs:\/\//, ""));
}
